/**
 * Compute the parent/child display title for a single catalog category.
 *
 * Catalog category names are only unique within their parent, so tabs and badges show the
 * nearest ancestor alongside the name ("Ovens / Accessories") to disambiguate. Roots — with
 * no ancestors — show the plain name. This fixed one-level form keeps every surface at a
 * predictable depth regardless of how deep the category actually sits.
 */
export function getCategoryTitle(category: { name: string; ancestor_names: string[] }): string {
    const nearestAncestor = category.ancestor_names.at(-1)
    return nearestAncestor ? `${nearestAncestor} / ${category.name}` : category.name
}

/** Compute the table tab id for a category, so the tabs and the header CTA agree on the active scope. */
export function getCategoryTabId(category: { id: number }): string {
    return `category_${category.id}`
}
